import { FormValidationSchema } from "@/components/Form/types";
import { I_RegisterPage } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { EMAIL_PATTERN } from "./patterns";

export const registerValidation = (
  data: I_RegisterPage,
  password: string
): FormValidationSchema[] => [
  {
    name: "email",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("email", "required", data),
      },
      pattern: {
        value: EMAIL_PATTERN,
        message: getRuleErrorMessage("email", "pattern", data),
      },
    },
  },
  {
    name: "password",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("password", "required", data),
      },
      pattern: {
        value: /(?!.*\s)(?=.*[a-z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,33}$/,
        message: getRuleErrorMessage("password", "pattern", data),
      },
    },
  },
  {
    name: "repeatPassword",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("repeatPassword", "required", data),
      },
      validate: (value) =>
        value === password || getRuleErrorMessage("repeatPassword", "validate", data),
    },
  },
];
